import { Button, Grid, Link, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { usePageUrl } from '../../../lib/pages'

const StyledHeading = styled(Grid)`
  align-self: center;
`

const StyledEditButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
    font-size: 0.75rem;
    // Needed to line up with the dollar amounts in \`TotalSummary\` due to negative margins on that container.
    margin-right: -15px;
    padding-right: 0;
    text-decoration: underline;
  }
` as typeof Button // cast to resolve type error when overriding component

export interface SummarySectionHeaderProps {
  className?: string
  navigateTo?: string
  showEdit?: boolean
  title: string
}

const SummarySectionHeader: React.FC<SummarySectionHeaderProps> = ({
  className,
  navigateTo = '',
  showEdit = false,
  title,
}) => {
  const { navigate } = usePageUrl()
  return (
    <Grid
      alignItems="flex-start"
      className={className}
      container
      item
      xs={12}
      justify="space-between"
    >
      <StyledHeading item>
        <Typography variant="overline">{title}</Typography>
      </StyledHeading>
      {showEdit && (
        <Grid item>
          <StyledEditButton component={Link} onClick={() => navigate(`/checkout/${navigateTo}`)}>
            Edit
          </StyledEditButton>
        </Grid>
      )}
    </Grid>
  )
}

const StyledSummarySectionHeader = styled(SummarySectionHeader)``

export default StyledSummarySectionHeader
